import { PassengerCountInitialValuesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";

export const usePassengerCount = (
  initialValues?: PassengerCountInitialValuesType
) => {
  const router = useRouter();
  const [temporaryPassengerCount, setTemporaryPassengerCount] = useState<{
    adult: number;
    child: number;
    room: number;
  }>({
    adult: initialValues?.adult || 1,
    child: initialValues?.child || 0,
    room: initialValues?.room || 1
  });
  const [passengerCount, setPassengerCount] = useState(temporaryPassengerCount);

  const { adult, child, room } = temporaryPassengerCount;

  const roomSpace = 15;
  const total = adult + child;
  const remain = roomSpace * room - total;
  const remainNotAdult = Math.min(remain, adult * 12 - child);

  const adultMax = adult + remain;
  // const adultMin = Math.max(Math.ceil(child / 12), 1);
  const childMax = child + remainNotAdult;
  // const childMin = 0;
  const roomMax =
    process.env.NEXT_PUBLIC_APP_NAME === "hotel-international" ? 1 : 15;
  const roomMin = 1;

  const onSubmitPassengerCount = useCallback(() => {
    setTemporaryPassengerCount((state) => {
      setPassengerCount(state);
      return state;
    });
  }, []);

  // const onChangeAdult = useCallback((value: number) => {
  //   setTemporaryPassengerCount((state) => ({
  //     ...state,
  //     adult: value
  //   }));
  // }, []);

  // const onChangeChild = useCallback((value: number) => {
  //   setTemporaryPassengerCount((state) => ({
  //     ...state,
  //     child: value
  //   }));
  // }, []);

  const onChangeRoom = useCallback((value: number) => {
    setTemporaryPassengerCount((state) => ({
      ...state,
      room: value
    }));
  }, []);

  const list = [
    // {
    //   increaseDisabled: adult >= adultMax,
    //   decreaseDisabled: adult <= adultMin,
    //   title: "تعداد بزرگسال",
    //   subtitle: "۱۲ سال به بالا",
    //   value: adult,
    //   onChange: onChangeAdult
    // },
    // {
    //   increaseDisabled: child >= childMax,
    //   decreaseDisabled: child <= childMin,
    //   title: "تعداد کودک",
    //   subtitle: "۲ تا ۱۲ سال",
    //   value: child,
    //   onChange: onChangeChild
    // },
    {
      increaseDisabled: room >= roomMax,
      decreaseDisabled: room <= roomMin,
      title: "تعداد اتاق",
      value: room,
      onChange: onChangeRoom
    }
  ];

  return {
    passengerCountTitle: "تعداد اتاق",
    passengerCountResult: `${numberConvert(passengerCount.room, {
      locale: router.locale
    })} اتاق`,

    passengerCountList: list,
    passengerCount,
    onSubmitPassengerCount,
    passengerCountValidation: {
      isPassengerDisabled: adult >= adultMax,
      isChildrenDisabled: child >= childMax,
      isSubmitDisabled: !(room * roomSpace >= total)
    }
  };
};
